const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL
      ? process.env.REACT_APP_API_BASE_URL
      : "/api"
  }
};

export default config;
